export default "__VITE_ASSET__B0O6SeZO__"